import { render } from "./MobileComponent.vue?vue&type=template&id=41ab62c8&scoped=true"
import script from "./MobileComponent.vue?vue&type=script&lang=js"
export * from "./MobileComponent.vue?vue&type=script&lang=js"

import "./MobileComponent.vue?vue&type=style&index=0&id=41ab62c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ab62c8"]])

export default __exports__